import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import CustomDialog from "../CustomDialog";
import { TimePicker } from "@mui/x-date-pickers";
import NullCheck from "components/NullCheck";


const TimePickerInput = ({
  control,
  title,
  name,
  required,
  errors,
  validation,
  disabled,
  defaultValue,
  width,
  min,
  max,
}) => {
  const { bt } = useBizTypeTranslation();
  const theme = useTheme()
  const [openMassge, setOpenMassge] = useState(false);
  const error = errors ? errors[name]?.ref?.name : false;
  const massge = errors ? errors[name]?.message : "";
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue ?? null}
        rules={{
          required: required ? bt("REQUIRED") : false,
          pattern: {
            value: validation?.regex,
            message: bt(validation?.massge),
          },
        }}
        render={({ field: { onChange, value } }) => (
          <TimePicker
            value={value ?? null}
            label={`${required ? "*" : ""}${title ? `${bt(title)}` : ""}`}
            sx={{ width: isMobile ? "100%" : width ? width : 200 }}
            minTime={min}
            maxTime={max}
            onChange={(e) => onChange(e)}
            disabled={disabled}
            onError={error}
            defaultValue={defaultValue ?? null}
          />
        )}
      />

      <NullCheck valueForCheck={massge}>
        <CustomDialog
          title="ERROR"
          open={openMassge}
          width={300}
          onClose={() => setOpenMassge(false)}
          closeBtn="CLOSE"
        >
          <Stack alignItems="center">
            {massge}
          </Stack>
        </CustomDialog>
      </NullCheck>
    </Stack>
  );
};
export default TimePickerInput;
